(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455,9495],{

/***/ 72535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(56237);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 84919:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(89824);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/Checkbox/Checkbox.module.scss
var Checkbox_module = __webpack_require__(46641);
var Checkbox_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_module);
;// CONCATENATED MODULE: ./components/Checkbox/Checkbox.tsx







var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var label = _param.label, checked = _param.checked, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, onChange = _param.onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "md" : _size, _color = _param.color, color = _color === void 0 ? "primary" : _color, _className = _param.className, className = _className === void 0 ? "" : _className, _labelClassName = _param.labelClassName, labelClassName = _labelClassName === void 0 ? "" : _labelClassName, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "checked",
        "defaultChecked",
        "onChange",
        "disabled",
        "size",
        "color",
        "className",
        "labelClassName",
        "error"
    ]);
    var _$ref = (0,react.useState)(defaultChecked), isChecked = _$ref[0], setIsChecked = _$ref[1];
    var _$ref1 = (0,react.useState)(false), isFocused = _$ref1[0], setIsFocused = _$ref1[1];
    // Stable across server/client render (unlike Math.random(), which caused
    // a hydration mismatch and, since it was called separately for the input
    // and the label, didn't even match its own htmlFor within one render).
    var generatedId = (0,react.useId)();
    var inputId = props.id || "checkbox-".concat(generatedId);
    var currentChecked = checked !== undefined ? checked : isChecked;
    var handleChange = function(e) {
        var newChecked = e.target.checked;
        if (checked === undefined) {
            setIsChecked(newChecked);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newChecked);
    };
    var handleFocus = function() {
        setIsFocused(true);
    };
    var handleBlur = function() {
        setIsFocused(false);
    };
    var checkboxClasses = [
        (Checkbox_module_default()).checkbox,
        (Checkbox_module_default())["size-".concat(size)],
        (Checkbox_module_default())["color-".concat(color)],
        currentChecked && (Checkbox_module_default()).checked,
        disabled && (Checkbox_module_default()).disabled,
        isFocused && (Checkbox_module_default()).focused,
        error && (Checkbox_module_default()).error,
        className, 
    ].filter(Boolean).join(" ");
    var labelClasses = [
        (Checkbox_module_default()).label,
        disabled && (Checkbox_module_default()).labelDisabled,
        error && (Checkbox_module_default()).labelError,
        labelClassName, 
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Checkbox_module_default()).checkboxContainer, " ").concat(error ? (Checkbox_module_default()).error : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: checkboxClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: ref,
                        type: "checkbox",
                        checked: currentChecked,
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        disabled: disabled,
                        className: (Checkbox_module_default()).input
                    }, props), {
                        id: inputId
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Checkbox_module_default()).checkboxBox,
                        style: error ? {
                            borderColor: "var(--color-error)"
                        } : {},
                        children: currentChecked && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: (Checkbox_module_default()).checkmark,
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10 3L4.5 8.5L2 6",
                                stroke: "#FFFFFF",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: inputId,
                className: labelClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    as: "span",
                    color: disabled ? "disabled" : error ? "error" : "secondary",
                    weight: "normal",
                    children: label
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/Checkbox/index.ts



/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 15516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _TextInput__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5166);
/* harmony import */ var _PhoneNumberInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96338);




/***/ }),

/***/ 89824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26538);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_PageWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96424);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39181);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99415);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70119);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32033);
/* harmony import */ var _contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97019);
/* harmony import */ var _contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50959);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57337);
/* harmony import */ var _components_TextInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15516);
/* harmony import */ var _components_Checkbox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62874);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38743);
















var ContactUsPage = function(param) {
    var aboutData = param.aboutData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), fileName = ref1[0], setFileName = ref1[1];
    var fileInputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var validationSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry({
        name: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Enter a full name"),
        email: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().email("Invalid email").required("Enter an email address like example@mysite.com."),
        phone: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().matches(/^[0-9+\-\s()]+$/, "Please enter a valid phone number"),
        company: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().max(100, "Company name is too long"),
        message: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Enter an answer."),
        privacy: yup__WEBPACK_IMPORTED_MODULE_4__/* .boolean */ .O7().oneOf([
            true
        ], "You must agree to the privacy policy.").required("You must agree to the privacy policy.")
    });
    var initialValues = {
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
        file: null,
        privacy: false
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(values, param) {
            var resetForm, formData, response, error, ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        resetForm = param.resetForm;
                        formData = new FormData();
                        formData.append("name", values.name);
                        formData.append("email", values.email);
                        if (values.phone) formData.append("phone", values.phone);
                        if (values.company) formData.append("company", values.company);
                        formData.append("message", values.message);
                        if (values.file) {
                            formData.append("file", values.file);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].post */ .Z.post("".concat("https://api.vxfx.io", "/contacts"), formData)
                        ];
                    case 2:
                        response = _state.sent();
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_7__/* ["default"].success */ .ZP.success("Your message has been sent successfully.");
                        // Reset form and file state
                        setFileName("");
                        resetForm();
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .ZP.error((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Something went wrong. Please try again.");
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFileDelete = function(setFieldValue) {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setFileName("");
        setFieldValue("file", null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Contact Us",
                description: "Contact EPEN Ltd. for video plugin development, software solutions & technical support. Our global team is ready to help. Get in touch today!",
                keywords: "contact, epen, support, video plugin development"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                dateText: "Contact us",
                title: "Contact Us",
                titleText: "We'd love to hear from you",
                introText: "We have offices and teams all around the world.",
                aboutData: aboutData,
                additionalHeaderContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfo),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItem),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemIcon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/contact-email.svg",
                                        alt: "Contact EPEN Ltd. via Email",
                                        width: 48,
                                        height: 48
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-lg",
                                            color: "grayDark-50",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-md",
                                            color: "grayDark-400",
                                            children: "Our friendly team is here to help."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:epen@epen.dev",
                                    style: {
                                        textDecoration: "none"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        variant: "text-md",
                                        color: "grayDark-300",
                                        as: "span",
                                        children: "epen@epen.dev"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItem),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemIcon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/contact-location.svg",
                                        alt: "EPEN Ltd. Office Location in Sofia, Bulgaria",
                                        width: 48,
                                        height: 48
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-lg",
                                            color: "grayDark-50",
                                            children: "Office"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-md",
                                            color: "grayDark-400",
                                            children: "Come say hello at our office HQ."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    variant: "text-md",
                                    color: "grayDark-300",
                                    children: "Racho Dimchev” Str., 1st floor, ap.1, Sofia, 1000, Bulgaria"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItem),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemIcon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/contact-phone.svg",
                                        alt: "Contact EPEN Ltd. via Phone",
                                        width: 48,
                                        height: 48
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactInfoItemContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-lg",
                                            color: "grayDark-50",
                                            children: "Phone"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                            variant: "text-md",
                                            color: "grayDark-400",
                                            children: "Mon-Fri from 8am to 5pm."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "tel:+35924372736",
                                    style: {
                                        textDecoration: "none"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        variant: "text-md",
                                        color: "grayDark-300",
                                        as: "span",
                                        children: "+35924372736"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contentSection),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    variant: "text-md",
                                    color: "grayDark-300",
                                    children: "Contact us"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    variant: "display-md",
                                    color: "grayDark-50",
                                    style: {
                                        marginBottom: "8px"
                                    },
                                    children: "Get in touch"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    variant: "text-xl",
                                    color: "grayDark-400",
                                    children: "We’d love to hear from you. Please fill out this form."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_15__/* .Formik */ .J9, {
                                initialValues: initialValues,
                                validationSchema: validationSchema,
                                onSubmit: handleSubmit,
                                validateOnChange: true,
                                validateOnBlur: true,
                                children: function(param) {
                                    var errors = param.errors, touched = param.touched, setFieldValue = param.setFieldValue, values = param.values, setFieldTouched = param.setFieldTouched;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_15__/* .Form */ .l0, {
                                        className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRowFullWidth),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                                    id: "name",
                                                    name: "name",
                                                    type: "text",
                                                    label: "Full name",
                                                    placeholder: "Enter your full name",
                                                    fullWidth: true,
                                                    required: true,
                                                    autoFocus: true,
                                                    value: values.name,
                                                    onChange: function(e) {
                                                        return setFieldValue("name", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("name", true);
                                                    },
                                                    error: touched.name && errors.name ? errors.name : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRowFullWidth),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                                    id: "email",
                                                    name: "email",
                                                    type: "email",
                                                    label: "Email",
                                                    placeholder: "Enter your email",
                                                    fullWidth: true,
                                                    required: true,
                                                    value: values.email,
                                                    onChange: function(e) {
                                                        return setFieldValue("email", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("email", true);
                                                    },
                                                    inputType: "email",
                                                    error: touched.email && errors.email ? errors.email : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRowFullWidth),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                                    id: "phone",
                                                    name: "phone",
                                                    type: "tel",
                                                    label: "Phone number",
                                                    placeholder: "Enter your phone number",
                                                    fullWidth: true,
                                                    inputType: "phone",
                                                    value: values.phone,
                                                    onChange: function(e) {
                                                        return setFieldValue("phone", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("phone", true);
                                                    },
                                                    error: touched.phone && errors.phone ? errors.phone : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRowFullWidth),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                                    id: "company",
                                                    name: "company",
                                                    type: "text",
                                                    label: "Company name",
                                                    placeholder: "Enter your company name",
                                                    fullWidth: true,
                                                    value: values.company,
                                                    onChange: function(e) {
                                                        return setFieldValue("company", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("company", true);
                                                    },
                                                    error: touched.company && errors.company ? errors.company : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRowFullWidth),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                                    id: "message",
                                                    name: "message",
                                                    label: "Message",
                                                    placeholder: "Leave us a message...",
                                                    fullWidth: true,
                                                    required: true,
                                                    multiline: true,
                                                    rows: 4,
                                                    value: values.message,
                                                    onChange: function(e) {
                                                        return setFieldValue("message", e.target.value);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("message", true);
                                                    },
                                                    error: touched.message && errors.message ? errors.message : undefined
                                                })
                                            }),
                                            fileName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fileContainer),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fileInfo),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fileLabel),
                                                                children: "Attached file:"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fileName),
                                                                title: fileName,
                                                                children: fileName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        type: "button",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handleFileDelete(setFieldValue);
                                                        },
                                                        "aria-label": "Remove ".concat(fileName),
                                                        className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().deleteBtn),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                            src: "/deleteicon.png",
                                                            alt: "Delete file",
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().formRow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Checkbox__WEBPACK_IMPORTED_MODULE_9__/* .Checkbox */ .X, {
                                                    id: "privacy",
                                                    name: "privacy",
                                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            "You agree to our friendly",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                                variant: "text-md",
                                                                as: "span",
                                                                color: "brand-500",
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    return window.open("/privacy-policy", "_blank");
                                                                },
                                                                children: "privacy policy"
                                                            })
                                                        ]
                                                    }),
                                                    required: true,
                                                    checked: values.privacy,
                                                    onChange: function(checked) {
                                                        return setFieldValue("privacy", checked);
                                                    },
                                                    onBlur: function() {
                                                        return setFieldTouched("privacy", true);
                                                    },
                                                    error: touched.privacy && errors.privacy ? errors.privacy : undefined
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().buttonRow),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                                        type: "submit",
                                                        fullWidth: true,
                                                        disabled: loading,
                                                        label: loading ? "Sending..." : "Send message"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                                        type: "button",
                                                        variant: "secondary",
                                                        fullWidth: true,
                                                        onClick: function() {
                                                            var ref;
                                                            (ref = fileInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                                        },
                                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M8 12L8 4M4 8L8 4L12 8",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }),
                                                        iconPosition: "right",
                                                        label: "Upload File"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "file",
                                                        accept: "image/*, application/pdf, .doc, .docx",
                                                        className: (_contact_us_module_scss__WEBPACK_IMPORTED_MODULE_14___default().filess),
                                                        ref: fileInputRef,
                                                        onChange: function(e) {
                                                            if (e.currentTarget.files) {
                                                                var ref;
                                                                setFileName(((ref = e.currentTarget.files[0]) === null || ref === void 0 ? void 0 : ref.name) || "");
                                                                setFieldValue("file", e.currentTarget.files[0]);
                                                            }
                                                        },
                                                        style: {
                                                            display: "none"
                                                        },
                                                        "aria-label": "File input"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactUsPage);


/***/ }),

/***/ 46641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__RNxPR","checkbox":"Checkbox_checkbox__exCc_","input":"Checkbox_input__nTZmL","checkboxBox":"Checkbox_checkboxBox__3vjaW","checkmark":"Checkbox_checkmark__BbcGW","label":"Checkbox_label__CbFqD","labelDisabled":"Checkbox_labelDisabled__QcFT8","labelError":"Checkbox_labelError__XD_a2","errorMessage":"Checkbox_errorMessage__tkOB6","size-sm":"Checkbox_size-sm__OKlpz","size-md":"Checkbox_size-md__2lRHw","size-lg":"Checkbox_size-lg__9tJW9","error":"Checkbox_error__ZlNjE","focused":"Checkbox_focused__R2964","color-primary":"Checkbox_color-primary__jn2Zo","color-secondary":"Checkbox_color-secondary__Eea0a","color-success":"Checkbox_color-success__pBbJr","color-warning":"Checkbox_color-warning__sjauP","color-error":"Checkbox_color-error__WB01Q","checked":"Checkbox_checked__lkDil","disabled":"Checkbox_disabled__dTK4V"};

/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 97019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"contact-us_contentSection__n8B65","contactInfo":"contact-us_contactInfo__GctyU","contactInfoItem":"contact-us_contactInfoItem__R7Kqj","contactInfoItemIcon":"contact-us_contactInfoItemIcon__6_cAz","contactInfoItemContent":"contact-us_contactInfoItemContent__cgx3h","title":"contact-us_title__ZstwF","formContainer":"contact-us_formContainer__KM31f","form":"contact-us_form__8wLDq","formRow":"contact-us_formRow__rSMDS","formRowFullWidth":"contact-us_formRowFullWidth__c7few","buttonRow":"contact-us_buttonRow__CAG41","fileContainer":"contact-us_fileContainer__aVFFK","fileInfo":"contact-us_fileInfo__n2zq_","fileLabel":"contact-us_fileLabel__9FFAH","fileName":"contact-us_fileName__KiDCH","deleteBtn":"contact-us_deleteBtn__3MJFE","attachBtn":"contact-us_attachBtn__K_JvG"};

/***/ }),

/***/ 60198:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 56237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(60198);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3053,3977,6538,6607,8030,5413,2033,5304,6309,5166,1407,9774,2888,179], function() { return __webpack_exec__(84919); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);